<template>
  <div class="">
      <div class="header-panel">
          <div class="container">
        <Heading 
        :preheading="'Bicycle Touring & Bikepacking'"
            :heading="'Book Directory'"
            :level = "1"
            

        />

            <!-- <Heading v-if="sub != null"
            :preheading="'Books About'"
                :heading="'Bike Touring in ' + $titleCase(sub)"
            

        /> -->

        <!-- <pre>{{sub}}</pre> -->

        <div class="">
            <div class="">
                <p class="is-size-5 is-size-6-mobile">
                    Welcome to the BikeSleepBike book directory, a collection of books about bikepacking and bicycle touring written by and for pedal-powered travelers. Find your next cycling adventure story based on location, route, riding style, and more.<br>
                    
                </p><br>
                <p class="is-size-7 is-size-7-mobile" style="max-width: 80%; margin-left:auto; margin-right:auto">How it works: Some links below are affiliate links, which means BikeSleepBike may earn a small commission at no extra cost to you if you buy through them.
                    The money helps pay for hosting and infrastructure costs of running this website. As an Amazon Associate I earn from qualifying purchases. Thanks!

                </p>
            </div>
            <div class="spacer" style="height:40px"></div>
        </div>
          </div>
      </div>

    <div class="spacer" style="height:60px"></div>
    <!-- <div class="small-label">Continent</div> -->
    <div class="container">
    <RadioFilter 
            v-on:selection-change="updateSelectedContinent"
            :options = "$continentsArray"
            :type = "'Continent'"
            :label="'Continent'"
           
        />

    <div class="spacer" style="height:30px"></div>
    <!-- <div class="small-label">Common Tags</div> -->
    <RadioFilter 
            v-on:selection-change="updateSelectedTag"
            :options = "['around the world','bikepacking', 'racing', 'couple', 'solo female', 'solo male', 'middle aged', 'Audible' ]"
            :type = "'book-tags'"
            :label = "'Popular Tags'"
        />
        

    <div class="spacer" style="height:60px"></div>

    <div class="block is-size-7" style="text-align:left; margin-bottom:5px">
            <!-- <span class="title is-size-6">Order By: </span> -->
            <b-radio v-model="orderby"
                native-value="year"
                type="is-info is-light">
                <span>Newest</span>
            </b-radio>

            <b-radio v-model="orderby"
                native-value="title"
                type="is-info is-light is-outlined is-small">
                <span>Alphabetical</span>
            </b-radio>
        </div>
    <div class="columns is-multiline is-variable is-3-desktop" v-if="!isLoading">
            
            <Book  
                v-for="book in books"
                v-bind:key = book.id
                :showBook="matchesTag(book, selectedTag)"
                :bookObj="book"
                :isMinimal="false"
            />
        
    </div>

     <div class="section card" ref="results" v-if="isLoading">
        <b-icon class="fas fa-spinner fa-spin"></b-icon>
        Loading...
    </div>
    <div class="section card" ref="results" v-if="!isLoading && books.length == 0">
        <!-- <b-icon class="fas fa-spinner fa-spin"></b-icon> -->
        None yet :(  You can <a href="https://docs.google.com/forms/d/e/1FAIpQLSfS5tuGghShUaw_PbSpOMz7Q7HS8uW87c19XQeYBxym9ETdIQ/viewform?usp=sf_link" target="_blank">submit a book</a> to start filling this section.
    </div>

      <div class="spacer" style="height:60px"></div>
      <a class="button is-large is-info" href="https://docs.google.com/forms/d/e/1FAIpQLSfS5tuGghShUaw_PbSpOMz7Q7HS8uW87c19XQeYBxym9ETdIQ/viewform?usp=sf_link" target="_blank" style="margin-bottom:15px">Submit a Book</a>
      <b-button v-if="books.length > 0" v-scroll-to="'#app'" class="is-large">Scroll to top</b-button>
        <div class="spacer" style="height:100px"></div>
    </div>
  </div>
</template>

<script>
import Heading from './Heading.vue'
import Book from './Book.vue'
import RadioFilter from './RadioFilter.vue'
export default {
  components: { Heading, Book, RadioFilter },
  name: 'Books',
//   props: ['sub'],
//   props: ['preheading', 'heading', 'subheading', 'noTitleCase'],
  data () {
    return {
      books:[],
      isLoading: false,
        noMorePages: false,
        lastVisibleResult: undefined,
        currentQuery: undefined,
        queryLimit: 200, // set really high so we're effectively not paginating here yet. If I do paginate, need to change the way continent and tag filters work (sort of impossible because some tags require two array-contains which isn't allowed)
        selectedContinent: this.sub == null ? "All" : this.sub,
        selectedTag: "All",
        orderby:"year",
        subs: {
            'book': {'heading': 'Books'}
        }
    }
  },
  watch: {
      orderby: function(oldval, newval) {
          this.fetchBooks(this.selectedContinent, this.orderby, (this.orderby == 'year' ? 'desc' : 'asc'));
      }

      
  },
  methods: {
      updateSelectedContinent(newContinent) {
          this.selectedContinent = newContinent;
          this.fetchBooks(this.selectedContinent, this.orderby, (this.orderby == 'year' ? 'desc' : 'asc'));
        //   var newPath = "";
        //   if (newContinent != 'All') {
        //       newPath = '/books/' + newContinent;
        //   } else {
        //       newPath = '/books';
        //   }
          
        //    this.$router.push({ path: newPath, params: { savedPosition: true } } ).catch(failure => { });
      },
      updateSelectedTag(tag) {
          this.selectedTag = tag;
      },
      matchesTag(book, tag) {
        //   console.log(book, tag);
        if (!tag || tag == '' || tag == 'All') {
            return true;
        } else if (book && tag) {
            if (tag == 'around the world' || tag == 'retired' || tag == 'solo female' || tag == 'solo male' || tag == 'couple' || tag =='middle aged') {
                // console.log(book.ridertags, tag);
                if (book.ridertags && book.ridertags.includes(tag)) {
                    return true;
                }
            } else if (tag == 'bikepacking' || tag == 'racing' || tag == 'Audible') {
                // console.log(book[tag]);
                if (book[tag.toLowerCase()]) {
                    return true;
                }
            } else {
                return false;
            }
        } else {
            return true;
        }
        return false;
        
          
      },
    fetchBooks(continent, sortby, sortorder) {
        if (this.$debug) {console.log("DEBUG: In function fetchPages");}
        
        // if (value != "") { // GET FILTERED
            this.$analytics.logEvent('fetch_results', { type: 'books by continent', value: continent});
            this.isLoading = true;
            var that = this;
            var result = [];
            this.noMorePages = false;
            this.lastVisibleResult = undefined;
            if (continent == 'All' || continent == '') {
                this.currentQuery = this.$db.collection("books");
            } else {
                this.currentQuery = this.$db.collection("books").where('continents', 'array-contains', continent);
            }
            this.currentQuery.orderBy(sortby, sortorder).limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.books = result;
                    that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting pages by style: ", error);
                    that.isLoading = false;
                });
        // } 
    },
    nextPage() {
            if (this.$debug) {console.log("DEBUG: In function nextPage");}
            var that = this;
            var result = [];  
        
            if (this.lastVisibleResult) {
                this.noMorePages = false;
                this.currentQuery.startAfter(this.lastVisibleResult).limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                      
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    // console.log("last");
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.books.push(...result);
                   
                })
                .catch(function(error) {
                    console.log("Error getting next chunk of page results: ", error);
                });         
            } else {
                this.noMorePages = true;
            }
        },
  },
  mounted() {
      this.fetchBooks(this.selectedContinent, this.orderby, (this.orderby == 'year' ? 'desc' : 'asc'));
  },
  metaInfo() {
        var title = 'Inspiring Books About Bicycle Touring and Bikepacking - Epic List Organized by Place and Style';
        var description = "These books have been tagged by location and style so you can find exactly the type of bicycle adventure you're most interested in. Touring or bikepacking, round the world or local, solo or family... It's all here to inspire your next bike trip.";
        return {
            title: title + (this.books.length ? ( " (" + this.books.length + ")" ) : '' ),
            titleTemplate: this.$titleTemplate,
            description: description,
            // title: title,
            titleTemplate: '%s | BikeSleepBike',
            // description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title },
                { name: "description", content: description  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "og:site_name", property: "og:site_name", content: "BikeSleepBike"  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>


// WEBPACK FOOTER //
// src/components/Books.vue